import BaseModelAPI from '../BaseModelAPI';

export default class ArchivedDocumentStatus extends BaseModelAPI {
	static entity = 'archiveddocumentstatus';
	static entityName = 'archiveddocumentstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}